<template>
  <div class="page" :class="{ 'page__has-bar': !readonly || (initData && canSignup()) }">
    <div class="page__bd">
      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__hd">
          <div class="weui-form-preview__item" style="text-align: center">
            <div class="weui-form-preview__value">{{ form.main.sa_name }}</div>
          </div>
        </div>
        <custom-layout
          class="weui-form-preview__bd"
          :view-config="customViewConfig"
        >
          <div class="weui-form-preview__item" slot="sa_begintime">
            <label class="weui-form-preview__label">{{
              customLabel.sa_begintime || "起始时间"
            }}</label>
            <span
              class="weui-form-preview__value"
              v-format="'yyyy-MM-dd hh:mm'"
              >{{ form.main.sa_begintime }}</span
            >
          </div>
          <div class="weui-form-preview__item" slot="sa_endtime">
            <label class="weui-form-preview__label">{{
              customLabel.sa_endtime || "结束时间"
            }}</label>
            <span
              class="weui-form-preview__value"
              v-format="'yyyy-MM-dd hh:mm'"
              >{{ form.main.sa_endtime }}</span
            >
          </div>
          <div class="weui-form-preview__item" slot="sa_address">
            <label class="weui-form-preview__label">{{
              customLabel.sa_address || "活动地点"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.sa_address
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="sa_organizer">
            <label class="weui-form-preview__label">{{
              customLabel.sa_organizer || "主办单位"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.sa_organizer
            }}</span>
          </div>
          <div
            class="weui-form-preview__item"
            v-if="form.main.sa_coorganizer"
            slot="sa_coorganizer"
          >
            <label class="weui-form-preview__label">{{
              customLabel.sa_coorganizer || "协办单位"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.sa_coorganizer
            }}</span>
          </div>
          <div
            class="weui-form-preview__item"
            v-if="form.main.sa_guest"
            slot="sa_guest"
          >
            <label class="weui-form-preview__label">{{
              customLabel.sa_guest || "特邀嘉宾"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.sa_guest
            }}</span>
          </div>
        </custom-layout>
      </div>

      <custom-layout :view-config="customViewConfig">
        <div
          class="form-preview weui-form-preview"
          v-show="form.main.sa_desc"
          slot="sa_desc"
        >
          <div class="weui-panel__hd">
            {{ customLabel.sa_desc || "活动详情" }}
          </div>
          <div class="weui-form-preview__bd">
            <div
              style="white-space: pre-wrap; text-align: left"
              v-html="form.main.sa_desc"
            ></div>
          </div>
        </div>
      </custom-layout>

      <div class="form-preview weui-form-preview">
        <custom-layout class="weui-form-preview__bd" :view-config="customViewConfig">
          <div class="weui-form-preview__item" slot="sa_contact">
            <label class="weui-form-preview__label">{{ customLabel.sa_contact || "联系人" }}</label>
            <span class="weui-form-preview__value">{{
              form.main.sa_contact
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="sa_contact_mob">
            <label class="weui-form-preview__label">{{ customLabel.sa_contact_mob || "联系电话" }}</label>
            <span class="weui-form-preview__value weui-form-preview__value-icon"
              >{{ form.main.sa_contact_mob }}
              <call-mobile :mobile="form.main.sa_contact_mob"></call-mobile>
            </span>
          </div>
        </custom-layout>
      </div>

      <div class="form-preview weui-form-preview" v-show="form.main.sa_attach">
        <div class="weui-panel__hd">宣传资料</div>
        <div class="weui-form-preview__bd">
          <file-list v-model="form.main.sa_attach" />
        </div>
      </div>

      <div
        class="form-preview weui-form-preview"
        v-show="form.main.sa_attach_col"
      >
        <div class="weui-panel__hd">活动集锦</div>
        <div class="weui-form-preview__bd">
          <file-list v-model="form.main.sa_attach_col" />
        </div>
      </div>

      <div
        class="form-preview weui-form-preview"
        v-if="!readonly && form.items2 && form.items2.length"
      >
        <div class="weui-panel__hd">人员名单</div>
        <div
          class="weui-form-preview__bd form-detail-preview"
          v-for="item in form.items2"
          :key="item.id"
        >
          <div class="form-detail-preview_num">{{ item.su_detno }}</div>
          <custom-layout :view-config="customViewConfig" position="detail1">
            <div class="weui-form-preview__item" slot="su_username">
              <label class="weui-form-preview__label">{{ customLabel.su_username || "姓名" }}</label>
              <span class="weui-form-preview__value">{{
                item.su_username
              }}</span>
            </div>
            <div class="weui-form-preview__item" v-if="item.su_gender" slot="su_gender">
              <label class="weui-form-preview__label">{{ customLabel.su_gender || "性别" }}</label>
              <span class="weui-form-preview__value">{{ item.su_gender }}</span>
            </div>
            <div class="weui-form-preview__item" slot="su_mobile">
              <label class="weui-form-preview__label">{{ customLabel.su_mobile || "联系电话" }}</label>
              <span
                class="weui-form-preview__value weui-form-preview__value-icon"
                >{{ item.su_mobile }}
                <call-mobile :mobile="item.su_mobile"></call-mobile>
              </span>
            </div>
            <div class="weui-form-preview__item" v-if="item.su_job" slot="su_job">
              <label class="weui-form-preview__label">{{ customLabel.su_job || "职位" }}</label>
              <span class="weui-form-preview__value">{{ item.su_job }}</span>
            </div>
            <div class="weui-form-preview__item" v-if="item.su_corpname" slot="su_corpname">
              <label class="weui-form-preview__label">{{ customLabel.su_corpname || "企业名称" }}</label>
              <span class="weui-form-preview__value">{{
                item.su_corpname
              }}</span>
            </div>
            <div class="weui-form-preview__item" v-if="item.su_signtime" slot="su_signtime">
              <label class="weui-form-preview__label">{{ customLabel.su_signtime || "签到时间" }}</label>
              <span class="weui-form-preview__value">{{ dateFormat(item.su_signtime,'yyyy-MM-dd hh:mm') }}</span>
            </div>
            <div class="weui-form-preview__item" slot="su_status">
              <label class="weui-form-preview__label">{{ customLabel.su_status || "签到状态" }}</label>
              <span class="weui-form-preview__value">{{
                item.su_status ? "已签到" : "未签到"
              }}</span>
            </div>
          </custom-layout>
        </div>
      </div>
    </div>

    <div class="footer-bar weui-dialog__ft" v-if="!readonly">
      <router-link
        :to="'/crm/activity_edit?id=' + form.main.id"
        v-if="editable"
        class="weui-dialog__btn weui-dialog__btn_primary"
        >编辑</router-link
      >
      <a
        href="javascript:;"
        v-if="editable"
        class="weui-dialog__btn weui-dialog__btn_primary"
        @click="f_audit"
        >审核</a
      >
      <a
        href="javascript:;"
        v-if="editable"
        class="weui-dialog__btn weui-dialog__btn_default"
        @click="p_remove"
        >删除</a
      >
      <router-link
        v-if="!editable"
        class="weui-dialog__btn weui-dialog__btn_primary"
        :to="'/crm/activity_qrcode/' + form.main.id"
        >签到二维码</router-link
      >
      <share
        class="weui-dialog__btn weui-dialog__btn_default"
        v-if="!editable"
        :biz-data="bizData"
        :qrcode-title="'活动报名'"
        :company="form.main.sa_organizer"
      ></share>
    </div>
    <div class="footer-bar weui-dialog__ft" v-else-if="readonly && initData && canSignup()">
      <router-link
        class="weui-dialog__btn weui-dialog__btn_primary"
        :to="'/open/crm/activity/signup_edit?uid=' + form.main.sa_uid"
        >我要报名</router-link
      >
    </div>
  </div>
</template>

<script>
import CustomLayout from "@/components/layout/CustomLayout.vue";
import FileList from "@/components/FileList.vue";
import CallMobile from "@/components/button/CallMobile.vue";
import process from "@/mixins/process.js";
import Share from "@/components/button/Share.vue";

export default {
  mixins: [process],
  components: {
    CustomLayout,
    FileList,
    CallMobile,
    Share,
  },
  data() {
    return {
      baseUrl: "/api/crm/activity",
      codeField: "sa_code",
      statusField: "sa_statuscode",
      caller: "SaleActivity",
    };
  },
  computed: {
    bizData() {
      var main = this.form.main;
      if (!main) {
        return null;
      }
      return {
        bizCode: main.sa_code,
        bizType: "SaleActivity",
        bizId: main.id,
        viewType: "crm-activity-formpanel",
        title: main.sa_name,
      };
    },
  },
  methods: {
    /**
     * 可否报名
     */
    canSignup() {
      var me = this,
        data = me.initData;
      if (!me.readonly || !data) {
        return false;
      }
      var fmt = "yyyy-MM-dd hh:mm:ss";
      return (
        me.dateFormat(data.main.sa_endtime, fmt) >
        me.dateFormat(new Date(), fmt)
      );
    },
    f_afterload(form) {
      document.title = form.main.sa_name;
    },
  },
};
</script>